import firebase from 'firebase/compat/app'
import { getAnalytics } from "firebase/analytics"
import "firebase/compat/auth";
import "firebase/compat/firestore";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";
import { getFunctions } from 'firebase/functions';
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// Firebase config file

const firebaseConfig = { 
  apiKey: "AIzaSyCSpmY0jTB7E6l2oUUopFspa2m8WIa9S1A", 
  authDomain: "feeling-italy.firebaseapp.com", 
  projectId: "feeling-italy", 
  storageBucket: "feeling-italy.appspot.com", 
  messagingSenderId: "588508418912", 
  appId: "1:588508418912:web:3db9b858a609d1b2144405"
}; 

// Init firebase
const app = firebase.initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const functions = getFunctions(app);
const auth = getAuth(app);
const firestoreDB = getFirestore(app);

// Init Services
const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider("6LeJhfIpAAAAAE8__WgoXCUGbgtvxrs0aAoKuH_l"),

  // Optional argument. If true, the SDK automatically refreshes App Check
  // tokens as needed.
  isTokenAutoRefreshEnabled: true,
});

export { app, auth, appCheck, functions, analytics, firestoreDB };